import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { CbtserviceService } from '../services/cbtservice.service';
import { ExamService } from '../services/exam.service';
import { LanguageService } from '../services/language.service';
import { SystemCheckService } from '../services/systemcheck.service';
import { ToastrService } from 'ngx-toastr';
import { CurrentUser } from '../models/CurrentUser';

@Component({
  selector: 'app-webcam-passport',
  templateUrl: './webcampassport.component.html',
  styleUrls: ['./webcampassport.component.css']
})
export class WebcamComponent implements OnInit, AfterViewInit {
  @Input() user: CurrentUser;
  @Output() imagefile: EventEmitter<any> = new EventEmitter<any>();

  constructor(public examservice: ExamService, private cbtService: CbtserviceService,private languageService: LanguageService, private systemCheckService: SystemCheckService, private toastrService: ToastrService) { }
  get language() {
    return this.languageService.language;
  }
  ngOnInit(): void {
  }

  @ViewChild("video")
  public video: ElementRef;

  @ViewChild("canvas")
  public canvas: ElementRef;

  //captured: string = "";
  firstCapturedImage: string = "";
  secondCapturedImage: string = "";
  error: any;
  isFirstImageCaptured: boolean;
  isSecondImageCaptured: boolean;
  saving: boolean = false;

  async ngAfterViewInit() {
    await this.checkdevice();
  }

  async checkdevice() {
    //if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      try {
        const stream = await this.cbtService.getVideoStream();
        if (stream) {
          this.video.nativeElement.srcObject = stream;
          this.video.nativeElement.play();
          this.error = null;
        } else {
          this.error = this.language.youhavenooutputvideodevice;
        }
      } catch (ex) {
        this.error = ex;
      }
    //}
  }

  async capture() {
    this.drawImageToCanvas(this.video.nativeElement);
    
    if(!this.isFirstImageCaptured){
      this.isFirstImageCaptured = true;
      this.firstCapturedImage = this.canvas.nativeElement.toDataURL("image/jpeg");
    }
    else{
      this.isSecondImageCaptured = true;
      this.secondCapturedImage = this.canvas.nativeElement.toDataURL("image/jpeg");
    }
  }

  async save() {
    this.saving = true;
    const minimumFaceAreaPercentage = 12;

    try{
      if(!this.user.skipaifacematching){
        const res = await this.systemCheckService.matchFaces(this.firstCapturedImage, this.secondCapturedImage);
        console.log('matching distance: ', res.faceAnalysis.distance);
        if(res.faceAnalysis.candidateFaceAreaPercentage && res.faceAnalysis.candidateFaceAreaPercentage < minimumFaceAreaPercentage){
          this.toastrService.error(this.language.pleaseEnsureYourFaceFillsTheCircleWhenTakingThePicture);
          this.removeCurrent();
          return;
        }
        if(res.faceAnalysis.candidateFaceAreaPercentage && res.faceAnalysis.detectedFaceAreaPercentage < minimumFaceAreaPercentage){
          this.toastrService.error(this.language.pleaseEnsureYourFaceFillsTheCircleWhenTakingThePicture);
          this.isSecondImageCaptured = false;
          this.secondCapturedImage = "";
          return;
        }
        if(res.faceAnalysis.candidateFaceIsNotAMatch || res.faceAnalysis.distance > 0.4){//the api allows a bigger distance, but we want to minimize the distance to give some allowance
          this.toastrService.error(this.language.faceMismatchPleaseRetakeThePicture);
          this.removeCurrent();
          return;
        }
        if(res.faceAnalysis.candidateFaceSmiling){
          this.toastrService.error(this.language.pleaseKeepANeutralExpressionForTheFirstPhoto);
          this.removeCurrent();
          return;
        }
        if(!res.faceAnalysis.detectedFaceSmiling){
          //throw new Error(this.language.pleaseSmileForTheSecondPhoto);
          this.toastrService.error(this.language.pleaseSmileForTheSecondPhoto);
          this.isSecondImageCaptured = false;
          this.secondCapturedImage = "";
          return;
        }
      }

      const arr = this.firstCapturedImage.split(",");
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      const file: File = new File([u8arr], this.user.username, { type: "jpeg" });

      this.imagefile.emit(file);

    }
    catch(error){
      this.toastrService.error(error.message);
      this.removeCurrent();
    }
    finally{
      this.saving = false;
    }
    //console.log(file);
  }

  removeCurrent() {
    this.isFirstImageCaptured = false;
    this.isSecondImageCaptured = false;
    this.saving = false;
    this.firstCapturedImage = "";
    this.secondCapturedImage = "";
  }

  // setPhoto() {
  //   this.isCaptured = true;
  //   var image = new Image();
  //   image.src = this.captured;
  //   this.drawImageToCanvas(image);
  // }

  drawImageToCanvas(video: any) {
    //the radius of the circle displayed is 40%. Which should make the total diameter (width) 80%
    const clippedWidth = video.videoWidth * .8;
    const clippedHeight = clippedWidth;
    this.canvas.nativeElement.width=clippedWidth
    this.canvas.nativeElement.height=clippedHeight
    const context = this.canvas.nativeElement.getContext("2d");
    context.scale(-1, 1);
    context.drawImage(video, (video.videoWidth - clippedWidth) / 2, (video.videoHeight - clippedHeight) / 2, clippedWidth, clippedHeight, 0, 0, clippedWidth*-1, clippedHeight);

    // this.canvas.nativeElement.width=video.videoWidth
    // this.canvas.nativeElement.height=video.videoHeight
    // const context = this.canvas.nativeElement.getContext("2d");
    // context.scale(-1, 1);
    // context.drawImage(video, 0, 0, this.canvas.nativeElement.width*-1, this.canvas.nativeElement.height);
  }
}
